import { useLazyGetUserChallengesQuery } from '../slices/fun_stuff/quizUsersSlice';
import { useDispatch } from 'react-redux';
import { setQuizChallenges } from '../slices/fun_stuff/quizAuthSlice';

export const useLoadQuizChallenges = () => {
  const dispatch = useDispatch();
  const [getChallenges, { isLoading, error }] = useLazyGetUserChallengesQuery();

  const loadChallenges = async () => {
    const data = await getChallenges().unwrap();
    dispatch(setQuizChallenges(data));
    return;
  };

  return { loadChallenges, isLoading, error };
};
